import {Fragment} from "react";
import BasicModal from "../../../../../../common/BasicModal";
import CustomFieldContainer from "./CustomFieldContainer";

export default function CustomFieldModal({title, open, handleClose, customFields, filterCustomFieldList, customFieldsInput, handleCustomFieldFormData}) {

    return(
        <Fragment>
            <BasicModal
                title={title}
                open={open}
                style={{width: '500px'}}
                handleClose={handleClose}>

                <CustomFieldContainer
                    handleClose={handleClose}
                    customFields={customFields}
                    filterCustomFieldList={filterCustomFieldList}
                    customFieldsInput={customFieldsInput}
                    handleCustomFieldFormData={handleCustomFieldFormData}
                />
            </BasicModal>
        </Fragment>
    )
}